function mapEventStatus(data) {
    return {
        state: data[0],
        isClockDisabled: data[1],
        period: data[2],
        minute: data[3],
        second: data[4],
        isClockRunning: data[5],
        homeTeamScore: data[6],
        awayTeamScore: data[7],
    };
}
function mapScorecard(data) {
    return {
        mainScorecard: data[0] ? mapScoreCard(data[0]) : undefined,
        scoreCards: data[1] ? data[1].map(mapScoreCard) : undefined,
        scorecardComponentId: data[2],
    };
}
function mapScoreCard(data) {
    return {
        intervalName: data[1],
        intervalNumber: data[2],
        firstTeamScore: data[3],
        secondTeamScore: data[4],
        liveScoreData: data[6]
    };
}
function mapTeam(data) {
    return {
        name: data[1],
    };
}
export function mapEvent(data) {
    return {
        eventId: data[0],
        displayGroupId: data[1],
        eventGroupId: data[2],
        eventGroupName: data[3],
        name: data[4],
        startDate: data[5].toString(),
        teamName1: data[6],
        teamName2: data[7],
        eventStatus: mapEventStatus(data[8]),
        tags: data[9],
        eventScorecard: data[11] ? mapScorecard(data[11]) : undefined,
        team1: data[12] ? mapTeam(data[12]) : undefined,
        team2: data[13] ? mapTeam(data[13]) : undefined,
    };
}
//# sourceMappingURL=mapEvent.js.map